/**
 * Sets a value in an object or array, handling both string keys (for objects) and numeric indices (for arrays).
 *
 * @param target - The object or array to set the value in.
 * @param key - The property name or array index as a string.
 * @param value - The value to set.
 * @param isArray - Whether the target is an array.
 */
export const setValueAtKey = (
  target: Record<string, unknown> | unknown[],
  key: string,
  value: unknown,
  isArray: boolean,
): void => {
  if (isArray) {
    const index = parseInt(key, 10);
    /* istanbul ignore else - NaN index is a no-op, item remains unchanged */
    if (!isNaN(index)) {
      (target as unknown[])[index] = value;
    }
  } else {
    (target as Record<string, unknown>)[key] = value;
  }
};
